/**
 * Graphology Browser GRAPHML Endpoint
 * ====================================
 *
 * Endpoint gathering both parser & writer for the browser.
 */
exports.parse = require('./parser.js');
